module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [(_vm.u) ? _c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v("Gebruikers")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'UserDetail',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.u.displayName))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "uk-align-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'UserEdit',
        params: {
          id: _vm.$route.params.id
        }
      },
      "uk-icon": "icon: pencil; ratio: 2"
    }
  })], 1), _vm._v(" "), _c('h1', [_vm._v(" " + _vm._s(_vm.u.displayName))]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-1"
  }, [_c('img', {
    staticClass: "round",
    attrs: {
      "src": _vm.u.photoURL
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('p', [_c('span', {
    staticClass: "uk-padding-small",
    attrs: {
      "uk-icon": "icon: mail"
    }
  }), _vm._v(_vm._s(_vm.u.email))])]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [(_vm.u.facebookLinked) ? _c('p', [_c('span', {
    staticClass: "uk-padding-small uk-text-success",
    attrs: {
      "uk-icon": "icon: check"
    }
  }), _vm._v("Linked with Facebook")]) : _c('p', [_c('span', {
    staticClass: "uk-padding-small uk-text-danger",
    attrs: {
      "uk-icon": "icon: close"
    }
  }), _vm._v("Not linked with Facebook")])]), _c('div', {
    staticClass: "uk-margin"
  }, [(!_vm.u.firstLogin) ? _c('p', [_c('span', {
    staticClass: "uk-padding-small uk-text-success",
    attrs: {
      "uk-icon": "icon: check"
    }
  }), _vm._v("Activated")]) : _c('p', [_c('span', {
    staticClass: "uk-padding-small uk-text-danger",
    attrs: {
      "uk-icon": "icon: close"
    }
  }), _vm._v("Inactive")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-284c0a5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/pages/UserDetail.vue
// module id = 508
// module chunks = 1